import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { handleApiErrors } from 'src/utils/error-handler';
import {
  DatedEvidence,
  EmptyComponent,
  Evidence,
  SnackbarContext,
} from '@eas/common-web';
import { Team } from '@models';
import { EvidenceApiUrl, Permission, regionApiErrors } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './team-columns';
import { Fields } from './team-fields';
import { useTeamHookedSources } from './team-hooked-sources';
import { useValidationSchema } from './team-schema';

export function Teams() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.TEAM_WRITE],
      EDIT: [Permission.TEAM_WRITE],
      REMOVE: [Permission.TEAM_WRITE],
    },
  });

  const { showSnackbar } = useContext(SnackbarContext);

  const evidence = DatedEvidence.useDatedEvidence<Team>({
    identifier: 'TEAM',
    apiProps: {
      url: EvidenceApiUrl.TEAMS,
      hookedSources: useTeamHookedSources,
      ...handleApiErrors(regionApiErrors.TEAM, showSnackbar),
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'ZSD__TEAMS__TABLE__TITLE',
        defaultMessage: 'Tímy',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__TEAMS__DETAIL__TITLE',
          defaultMessage: 'Tímy',
        }),
        subtitle: (team) => team?.name ?? '',
        showBtn: btnPermissions,
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
